export default __webpack_public_path__ + "static/media/7.b8bc935d.png";